<div [ngClass]="{ 'fgbcl-predictor': groupType == groupTypes.Predictor, 'fgbcl-trivia': groupType == groupTypes.Trivia }">
  <ng-container *ngIf="answers[0].ImageUrl">
    <img
      class="fgbcl-game-predictor-counter-answer-image"
      [src]="answers[0].ImageUrl | contentImage: '7'"
      alt="{{ answers[0].Title }}"
    />
  </ng-container>
  <div class="d-flex align-items-center justify-content-center">
    <fgbcl-counter (countEmitter)="onAnswerSelected(answers[0].Id, $event)" [count]="answers[0].Value"></fgbcl-counter>
  </div>
</div>
